import _reduxForm from "redux-form/es/reduxForm";
import _Field from "redux-form/es/Field";
import React from 'react';
import classnames from 'classnames';
import utilClasses from 'swag-client-common/styles/utilities.scss';
import UnderlinedInput from 'swag-client-common/components/inputs/underlined-input';
import { email, required } from 'swag-client-common/utils/redux-form-validators';
import { Button } from 'swag-client-common/components/ui/button';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import { TOO_MANY_ATTEMPTS_ERROR_TEXT } from 'swag-client-common/constants';
import classes from './login-form.scss';
export const validate = values => {
  const errors = {};
  if (!values.login) {
    errors.login = 'This field is required';
  }
  if (!values.password) {
    errors.password = 'This field is required';
  }
  return errors;
};
const LoginForm = ({
  handleSubmit,
  onSubmit,
  isLabelFixed,
  notVerifiedEmail,
  isAccountBannedByIp,
  onPasswordForgot,
  onShowSignUp,
  isLoading,
  isError,
  errorMessage,
  onResendVerificationEmail,
  isSignUpAllowed = true,
  additionalText,
  isLimitedEdition,
  title = 'Log in',
  className = ''
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.loginWrapper, className)
  }, /*#__PURE__*/React.createElement("h2", {
    className: classes.title
  }, title), additionalText && /*#__PURE__*/React.createElement("div", null, additionalText), isError && /*#__PURE__*/React.createElement("div", {
    className: classes.error,
    "data-label": "ErrorGeneral"
  }, isAccountBannedByIp ? TOO_MANY_ATTEMPTS_ERROR_TEXT : errorMessage), /*#__PURE__*/React.createElement("form", {
    className: classnames(utilClasses.textCenter, classes.form),
    onSubmit: handleSubmit && onSubmit && handleSubmit(onSubmit),
    autoComplete: "off"
  }, /*#__PURE__*/React.createElement(_Field, {
    name: "login",
    component: UnderlinedInput,
    type: "text",
    validate: [required, email],
    label: "Your email",
    dataInput: "Email",
    autoComplete: "off",
    floatingLabelFixed: isLabelFixed,
    errorClassName: classes.errorClassName,
    className: classes.classNameInput
  }), /*#__PURE__*/React.createElement(_Field, {
    name: "password",
    component: UnderlinedInput,
    type: "password",
    validate: [required],
    label: "Your password",
    dataInput: "Password",
    autoComplete: "off",
    floatingLabelFixed: isLabelFixed,
    errorClassName: classes.errorClassName,
    className: classes.classNameInput,
    shouldShowPassword: false
  }), /*#__PURE__*/React.createElement("span", {
    onClick: onPasswordForgot,
    className: classnames(classes.forgotPassword, utilClasses.smallGreyText),
    "data-label": "ForgotPassword",
    onKeyDown: e => handleOnEnterPressed(e, onPasswordForgot),
    tabIndex: 0
  }, "Forgot password?"), /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    size: "small",
    loading: isLoading,
    dataButton: "Login",
    className: classnames(classes.submitButton, {
      [classes.orangeBackground]: isLimitedEdition
    })
  }, "Log in"), notVerifiedEmail && /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.verificationEmailLink, utilClasses.smallGreyText)
  }, "Click", ' ', /*#__PURE__*/React.createElement("span", {
    className: classnames(utilClasses.smallBlueText, utilClasses.actionElement),
    onClick: onResendVerificationEmail
  }, "here"), ' ', "if you want us to resend you a verification email")), isSignUpAllowed && /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "Don't have an account?", ' ', /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.link, {
      [classes.orangeColor]: isLimitedEdition
    }),
    onClick: onShowSignUp,
    onKeyDown: e => handleOnEnterPressed(e, onShowSignUp),
    "data-label": "GetStarted",
    tabIndex: 0
  }, "Get started")));
};
const LoginReduxForm = _reduxForm({
  form: 'login',
  validate
})(LoginForm);
export { LoginReduxForm as LoginForm };